import React, {useEffect} from 'react';
import * as yup from 'yup';
import {useNavigate, useParams} from 'react-router-dom';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup/dist/yup';
import {aiSettingsApi} from '../../../../api';
import {IAiSettings} from '../interfaces/IAiSettings';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {Card, CardBody, Col, Form, Row} from 'reactstrap';

import {useTranslation} from 'react-i18next';
import AiSettingsForm from './AiSettingsForm';

export const aiSettingsFormSchema = yup
  .object({
    assistantPrompt: yup.string().required('No prompt provided.').min(3, 'Prompt is too short - should be 3 chars minimum.'),
  })
  .required();
const AiSettingsUpdate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {id} = useParams();
  const methods = useForm<IAiSettings>({
    resolver: yupResolver(aiSettingsFormSchema),
  });

  const onFormSubmit = async (formData: IAiSettings) => {
    const {data} = await aiSettingsApi.updateSettings(Number(id), formData);
    data && navigate(-1);
  };

  useEffect(() => {
    if (id) {
      const getPrompt = async (promptId: number) => {
        const {data} = await aiSettingsApi.getSettings(+promptId);
        methods?.reset(data);
      };
      getPrompt(+id);
    }
  }, [id, methods]);
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('administrator.aiSettings.aiSettingsUpdate')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate('/app/admin/ai-settings');
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods?.handleSubmit(onFormSubmit)} className="py-3">
              <AiSettingsForm register={methods?.register} errors={methods?.formState?.errors} />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.update')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default AiSettingsUpdate;
